import { defineComponent as _defineComponent } from 'vue'
import Modal from '@/components/Modal/Modal.vue'
import { Icon } from '@iconify/vue2'
import TelegramLinkQrCode from './TelegramLinkQrCode.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TelegramModal',
  props: {
    userId: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'close'): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, Modal, Icon, TelegramLinkQrCode }
}

})